export const assertServiceHost = (host?: string): string => {
  if (!host) {
    throw new Error('Empty service host');
  }
  return host;
};

export const buildQuery = (query: unknown): string => {
  let queryParams = '';
  if (query && typeof query === 'object') {
    const params: string[] = [];
    for (const k in query) {
      if (Object.prototype.hasOwnProperty.call(query, k)) {
        const v = (query as Record<string, unknown>)[k];
        if (null !== v && undefined !== v) {
          if ('object' === typeof v) {
            params.push(`${k}=${encodeURIComponent(JSON.stringify(v))}`);
          } else {
            params.push(`${k}=${encodeURIComponent(String(v))}`);
          }
        }
      }
    }
    queryParams = params.join('&');
  }
  return queryParams;
};
